import React, { FC, useMemo } from 'react';
import { SelectProps } from 'formik-antd/src/select/index';
import { Select } from 'formik-antd';
import { DeviceStatus, deviceStatusLabelMap } from 'models/higoDevice';
import { UserStatusExisting, userStatusLabelMap } from 'models/userStatus';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const DeviceStatusSelect: FC<SelectProps> = (props) => {
  const intlMessage = useFormatMessage();

  const options = useMemo(
    () => (
      <>
        <Select.Option key={'all'} value={'all'}>
          {intlMessage({ id: 'all' })}
        </Select.Option>
        {Object.values(DeviceStatus).map((x: any) => (
          <Select.Option key={x} value={x}>
            {intlMessage({ id: deviceStatusLabelMap.get(x) })}
          </Select.Option>
        ))}
      </>
    ),
    [intlMessage]
  );

  return <Select {...props}>{options}</Select>;
};

export const UserStatusSelect: FC<SelectProps> = (props) => {
  const intlMessage = useFormatMessage();

  const options = useMemo(
    () =>
      Object.values(UserStatusExisting).map((x: any) => (
        <Select.Option key={x} value={x}>
          {intlMessage({ id: userStatusLabelMap.get(x) })}
        </Select.Option>
      )),
    [intlMessage]
  );

  return <Select {...props}>{options}</Select>;
};

export const PartnerStatusSelect: FC<SelectProps> = (props) => {
  const intlMessage = useFormatMessage();

  return (
    <Select {...props}>
      <Select.Option key={'all'} value={'all'}>
        {intlMessage({ id: 'all' })}
      </Select.Option>
      <Select.Option key={'active'} value={'true'}>
        {intlMessage({ id: 'status.active' })}
      </Select.Option>
      <Select.Option key={'inactive'} value={'false'}>
        {intlMessage({ id: 'status.deactivated' })}
      </Select.Option>
    </Select>
  );
};
